import styled from 'styled-components'

export const Container = styled.button<{ selected?: boolean }>`
  outline: none;
  border: none;

  width: 32px;
  height: 20px;

  border-radius: 999px;
  background: ${({ selected }) =>
    selected ? 'var(--Background-Primary, #5a58f2)' : 'var(--Border-Neutral-faded, #DFE2EA)'};

  transition: background 0.15s cubic-bezier(0.7, 0.01, 0.23, 1.01);

  cursor: pointer;

  :disabled {
    cursor: default;
    opacity: 0.5;
  }

  position: relative;
`

export const CircleContainer = styled.div<{ selected?: boolean }>`
  position: absolute;

  top: 1px;
  left: ${({ selected }) => (selected ? 10 : 1)}px;

  transition: left 0.15s cubic-bezier(0.7, 0.01, 0.23, 1.01);
`
